import React from 'react'
import { FaTimes } from 'react-icons/fa';

function ConnectionForm({ setConnection}) {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-gray-100 border-2 border-gray-800 rounded-lg w-full max-w-2xl overflow-y-auto p-4">
          <div className="flex justify-between items-center border-b-2 border-gray-700 pb-2 mb-4">
            <p className="text-lg font-semibold">Your Details</p>
            <FaTimes onClick={() => setConnection(false)} className="cursor-pointer hover:text-red-600 transition-transform hover:scale-125 duration-300" />
          </div>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="mb-4">
              <label className="block">Full Name</label>
              <input type="text" placeholder="Full Name" className="w-full p-2 border-2 border-gray-800 rounded bg-transparent" />
            </div>
            <div className="mb-4">
              <label className="block">Mobile Number</label>
              <input type="number" placeholder="Mobile Number" className="w-full p-2 border-2 border-gray-800 rounded bg-transparent" />
            </div>
            <div className="mb-4">
              <label className="block">Email</label>
              <input type="email" placeholder="Email" className="w-full p-2 border-2 border-gray-800 rounded bg-transparent" />
            </div>
            <div className="mb-4">
              <label className="block">Select Plan</label>
              <select className="w-full p-2 border-2 border-gray-800 rounded bg-transparent">
                <option value="350">Premium Plan (350 Mbps)</option>
                <option value="200">Standard Plan (200 Mbps)</option>
                <option value="100">Basic Plan (100 Mbps)</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block">City</label>
              <input type="text" placeholder="City" className="w-full p-2 border-2 border-gray-800 rounded bg-transparent" />
            </div>
            <div className="mb-4">
              <label className="block">Area</label>
              <input type="text" placeholder="Area" className="w-full p-2 border-2 border-gray-800 rounded bg-transparent" />
            </div>
            <button type="submit" className="w-full bg-green-600 text-white p-2 rounded mt-2 hover:bg-green-800">Submit</button>
          </form>
        </div>
      </div>
  )
}

export default ConnectionForm